import React from "react";
import { Container, Row, Col, Image } from "react-bootstrap";
import "./Details_blog.css";
import Common_Banner from "../../common-components/common-banner/Common_Banner";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarDays } from "@fortawesome/free-solid-svg-icons";

const Details_blog = () => {
  const breadcrumbs = [
    { label: "Home", link: "/", isActive: false },
    { label: "BLOGS", link: "", isActive: true },
  ];
  return (
    <>
      <Common_Banner
        imgSrc={"/assets/images/common_banners/blogs_banner.png"}
        title_text="Detail Blogs Page"
        breadcrumbs={breadcrumbs}
      />
      <section className="blog_details">
        <Container>
          <Row>
            <Col lg={8} md={12}>
              <div className="blog_main">
                <div className="blog_date">
                  <FontAwesomeIcon icon={faCalendarDays} className="icon" /> 08
                  October, 2025
                </div>

                <div className="blog_image">
                  <Image
                    src="/assets/images/blog/running.png"
                    alt="Improve Your Stamina"
                  />
                </div>

                <div className="blog_author">
                  <Image
                    src="/assets/images/blog/coach.png"
                    alt="Coach Anita"
                    roundedCircle
                    className="author_img"
                  />
                  <p className="author_name">By Coach Anita</p>
                </div>

                <div className="blog_content">
                  <h2 className="blog_title">5 Tips to Improve Your Stamina</h2>
                  <p className="blog_text">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed
                    non risus. Suspendisse lectus tortor, dignissim sit amet,
                    adipiscing nec, ultricies sed, dolor . Cras elementum
                    ultrices diam. Maecenas ligula massa, varius a, semper
                    congue, euismod non, mi. Proin porttitor, orci nec nonummy
                    molestie, enim est eleifend mi, non fermentum diam nisl sit
                    amet erat. Duis semper. Duis arcu massa, scelerisque vitae,
                    consequat in, pretium a, enim. Pellentesque congue. Ut in
                    risus volutpat libero pharetra tempor. Cras vestibulum
                    bibendum augue. Praesent egestas leo in pede. Praesent
                    blandit odio eu enim. Pellentesque sed dui ut augue blandit
                    sodales. Vestibulum ante ipsum primis in faucibus orci
                    luctus et ultrices posuere cubilia Curae; Aliquam nibh.
                    Mauris ac mauris sed pede pellentesque fermentum. Maecenas
                    adipiscing ante non diam sodales hendrerit.{" "}
                  </p>
                  <p className="blog_text">
                    Ut velit mauris, egestas sed, gravida nec, ornare ut, mi.
                    Aenean ut orci vel massa suscipit pulvinar. Nulla
                    sollicitudin. Fusce varius, ligula non tempus aliquam, nunc
                    turpis ullamcorper nibh, in tempus sapien eros vitae ligula.
                    Pellentesque rhoncus nunc et augue. Integer id felis.
                    Curabitur aliquet pellentesque diam. Integer quis metus
                    vitae elit lobortis egestas. Lorem ipsum dolor sit amet,
                    consectetuer adipiscing elit. Morbi vel erat non mauris
                    convallis vehicula. Nulla et sapien. Integer tortor tellus,
                    aliquam faucibus, convallis id, congue eu, quam. Mauris
                    ullamcorper felis vitae erat. Proin feugiat, augue non
                    elementum posuere, metus purus iaculis lectus, et tristique
                    ligula justo vitae magna.
                  </p>
                  <p className="blog_text">
                    Aliquam convallis sollicitudin purus. Praesent aliquam, enim
                    at fermentum mollis, ligula massa adipiscing nisl, ac
                    euismod nibh nisl eu lectus. Fusce vulputate sem at sapien.
                    Vivamus leo. Aliquam euismod libero eu enim. Nulla nec felis
                    sed leo placerat imperdiet. Aenean suscipit nulla in justo.
                    Suspendisse cursus rutrum augue. Nulla tincidunt tincidunt
                    mi. Curabitur iaculis, lorem vel rhoncus faucibus, felis
                    magna fermentum augue, et ultricies lacus lorem varius
                    purus. Curabitur eu amet. Aliquam erat volutpat. Suspendisse
                    potenti. Cras in mi at felis aliquet congue. Ut a est eget
                    ligula molestie gravida. Curabitur massa. Donec eleifend,
                    libero at sagittis mollis, tellus est malesuada tellus, at
                    luctus turpis elit sit amet quam. Vivamus pretium ornare
                    est.{" "}
                  </p>
                  <p className="blog_text">
                    Praesent dapibus, neque id cursus faucibus, tortor neque
                    egestas auguae, eu vulputate magna eros eu erat. Aliquam
                    erat volutpat. Nam dui mi, tincidunt quis, accumsan
                    porttitor, facilisis luctus, metus. Phasellus ultrices nulla
                    quis nibh. Quisque a lectus. Donec consectetuer ligula
                    vulputate sem tristique cursus. Nam nulla quam, gravida non,
                    commodo a, sodales sit amet, nisi. Pellentesque fermentum
                    dolor. Aliquam quam lectus, facilisis auctor, ultrices ut,
                    elementum vulputate, nunc. Sed adipiscing ornare risus.
                    Morbi est est, blandit sit amet, sagittis vel, euismod vel,
                    velit. Pellentesque habitant morbi tristique senectus et
                    netus et malesuada fames ac turpis egestas.
                  </p>
                  <p className="blog_text">
                    In convallis. Nunc tincidunt ante vitae massa. Sed convallis
                    magna eu sem. Proin ut ligula vel nunc egestas porttitor.
                    Morbi lectus risus, iaculis vel, suscipit quis, luctus non,
                    massa. Fusce ac turpis quis ligula lacinia aliquet. Mauris
                    ipsum. Nulla metus metus, ullamcorper vel, tincidunt sed,
                    euismod in, nibh. Quisque volutpat condimentum velit. Class
                    aptent taciti sociosqu ad litora torquent per conubia
                    nostra, per inceptos himenaeos. Nam nec ante. Sed lacinia,
                    urna non tincidunt mattis, tortor neque adipiscing diam, a
                    cursus ipsum ante quis turpis. Nulla facilisi. Ut fringilla.
                    Suspendisse potenti. Nunc feugiat mi a tellus consequat
                    imperdiet. Vestibulum sapien. Proin quam. Etiam ultrices.{" "}
                  </p>
                  <p className="blog_text">
                    Suspendisse in justo eu magna luctus suscipit. Sed lectus.
                    Integer euismod lacus luctus magna. Quisque cursus, metus
                    vitae pharetra auctor, sem massa mattis sem, at interdum
                    magna augue eget diam. Vestibulum ante ipsum primis in
                    faucibus orci luctus et ultrices posuere cubilia Curae;
                    Morbi lacinia molestie dui. Praesent blandit dolor. Sed non
                    quam. In vel mi sit amet augue congue elementum. Morbi in
                    ipsum sit amet pede facilisis laoreet. Donec lacus nunc,
                    viverra nec.
                  </p>
                </div>
              </div>
            </Col>

            {/* === Sidebar Latest Posts === */}
            <Col lg={4} md={12}>
              <div className="blog_sidebar">
                <h4 className="sidebar_title">Latest Post</h4>

                <div className="sidebar_post">
                  <Image
                    src="/assets/images/blog/martial_arts.png"
                    alt="Martial Arts"
                    className="sidebar_img"
                  />
                  <div className="sidebar_text">
                    <h6 className="side_head">
                      Beginner’s Guide to Martial Arts
                    </h6>
                    <span className="side_p">09 October, 2025</span>
                  </div>
                </div>

                <div className="sidebar_post">
                  <Image
                    src="/assets/images/blog/yoga.png"
                    alt="Healthy Back"
                    className="sidebar_img"
                  />
                  <div className="sidebar_text">
                    <h6 className="side_head">
                      Top 10 Exercises for a Healthy Back
                    </h6>
                    <span className="side_p">10 October, 2025</span>
                  </div>
                </div>

                <div className="sidebar_post">
                  <Image
                    src="/assets/images/blog/martial_arts.png"
                    alt="Martial Arts"
                    className="sidebar_img"
                  />
                  <div className="sidebar_text">
                    <h6 className="side_head">
                      Beginner’s Guide to Martial Arts
                    </h6>
                    <span className="side_p">09 October, 2025</span>
                  </div>
                </div>

                <div className="sidebar_post">
                  <Image
                    src="/assets/images/blog/yoga.png"
                    alt="Healthy Back"
                    className="sidebar_img"
                  />
                  <div className="sidebar_text">
                    <h6 className="side_head">
                      Top 10 Exercises for a Healthy Back
                    </h6>
                    <span className="side_p">10 October, 2025</span>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default Details_blog;
